module.exports = __webpack_public_path__ + "img/go.20f3b599.png";